import OrdersList from "@/views/orders/OrdersList.vue";
import LicenseView from "@/views/LicenseView.vue";
import SubscriptionOrderView from "@/views/SubscriptionOrderView.vue";

export const orderRoutes = [
  {
    path: "/dashboard/orders",
    name: "Orders",
    component: OrdersList,
    meta: {
      name: "Orders",
      breadcrumbs: ["Dashboard", "Orders"],
    },
  },
  {
    path: "/dashboard/licences",
    name: "Licences",
    component: OrdersList,
    meta: {
      name: "Licences",
      breadcrumbs: ["Dashboard", "Licences"],
    },
  },
  {
    path: "/dashboard/licences/:oid/:lid",
    name: "Licence",
    component: LicenseView,
    meta: {
      name: "Licence",
      breadcrumbs: ["Dashboard", "Licences", "Licence"],
    },
  },
  {
    path: "/dashboard/subscriptions",
    name: "Subscriptions",
    component: OrdersList,
    meta: {
      name: "Subscriptions",
      breadcrumbs: ["Dashboard", "Subscriptions"],
    },
  },
  {
    path: "/dashboard/orders/subscriptions/:id",
    name: "Subscription Order",
    component: SubscriptionOrderView,
    meta: {
      name: "Subscription Order",
      breadcrumbs: ["Dashboard", "Subscriptions", "Subscription Order"],
    },
  },
];
